import React from 'react';
import { motion } from 'framer-motion';

const RegistryPromo = () => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden bg-white">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-luma-sage/10 -skew-x-12 translate-x-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
          
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <div className="aspect-[4/5] rounded-[40px] overflow-hidden shadow-2xl">
                <img 
                  src="https://images.unsplash.com/photo-1519689680058-324335c77eba?auto=format&fit=crop&q=80&w=1200" 
                  alt="Mom and baby" 
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Floating Stat Card */}
              <motion.div 
                whileInView={{ x: [20, 0], opacity: [0, 1] }}
                className="absolute -bottom-10 -right-6 md:right-10 bg-white p-6 md:p-8 rounded-3xl shadow-2xl max-w-[200px] md:max-w-[240px]"
              >
                <div className="flex items-baseline gap-2 mb-2">
                  <span className="text-3xl font-serif text-luma-primary italic">15%</span>
                  <span className="text-[10px] uppercase font-bold tracking-widest text-luma-text/60">Reward</span>
                </div>
                <p className="text-xs text-luma-text/80 leading-relaxed">Registry completion discount for all essentials.</p>
              </motion.div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="text-luma-primary text-[10px] font-bold tracking-[0.3em] uppercase mb-6 block">The LumaBaby Way</span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-luma-text mb-8 leading-[1.1]">
              Preparation <br/> <span className="italic">simplified</span>.
            </h2>
            <p className="text-base md:text-lg text-luma-text/60 mb-10 leading-relaxed font-light">
              We've redesigned the registry experience to be as peaceful as your nursery. Our curated checklist ensures you have exactly what you need, and nothing you don't.
            </p>
            
            <div className="space-y-6 mb-12">
              {[
                { title: 'Welcome Box', desc: 'A curated selection of favorites for new parents.' },
                { title: 'Gift Tracker', desc: 'Seamlessly track and thank your loved ones.' },
                { title: 'Expert Support', desc: '1-on-1 consultations with our registry specialists.' }
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-5 group">
                  <div className="w-6 h-6 rounded-full border border-luma-sand flex items-center justify-center shrink-0 mt-1 group-hover:border-luma-primary transition-colors">
                    <div className="w-1.5 h-1.5 rounded-full bg-luma-primary"></div>
                  </div>
                  <div>
                    <h4 className="font-bold text-xs uppercase tracking-widest mb-1">{item.title}</h4>
                    <p className="text-sm text-luma-text/50">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <button className="bg-luma-text text-white px-12 py-5 rounded-full text-xs font-bold tracking-widest uppercase hover:bg-luma-primary transition-all duration-300">
              Create Your Registry
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RegistryPromo;